<template>
  <div class="training_table">
    <div class="waitingcom_title">
      <el-form
        label-width="80px"
        :model="formLabelAlign"
        ref="formLabelAlign"
        :label-position="labelPosition"
      >
        <el-form-item label="操作名称：" prop="operationName">
          <el-input
            v-model.trim="formLabelAlign.operationName"
            placeholder="请输入操作名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="操作状态：" prop="operationModel">
          <el-select
            v-model.trim="formLabelAlign.operationModel"
            label="全部"
            @change="searchChang"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in modelArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考核时间：" prop="examTime">
          <div class="block">
            <el-date-picker
              @change="searchChang"
              v-model="examTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="创建开始日期"
              end-placeholder="创建结束日期"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div class="query_btn">
        <el-button
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          :loading="sundflag"
          @click="searchData()"
          >搜索</el-button
        >
        <el-button
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          @click.prevent.stop="resetForm('formLabelAlign')"
          >重置</el-button
        >
      </div>
    </div>
    <Table
      ref="table"
      :tableObj="tableObj"
      :toAdd="toAdd"
      :stateColor="stateColor"
      :qrObj="qrObj"
      @row="getRow"
      :fun1="fun1"
      :fun2="fun2"
      :fun3="fun3"
      :fun4="fun4"
      :disabledFun="disabledFun"
      :buttonShowClick="buttonShowClick"
      :pageIndexs="pageIndexs"
      :eachPageNums="eachPageNums"
    />
    <div class="foot_box">
      <div class="foot_pagetions">
        <p></p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndexs"
          :page-size="eachPageNums"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
    <Popups ref="Popups" />
    <!--  提示弹窗 -->
    <ComPopup :prompt="prompt" ref="ComPopup" :fun2="exportExam" />
  </div>
</template>

<script>
import Table from "@/components/progress/Table.vue";
import { operationTable, modelArr } from "@/state/operation";
import { hybrid } from "@/mixin/mixin";
import assessApi from "@/api/assessment";
import Popups from "./Popups.vue";
import ComPopup from "@/components/ComPopup.vue";
import loginvuex from "@/store/index";

export default {
  data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        operationName: "", // 操作名称
        operationModel: "", // 操作状态
        beginTime: "", // 起始时间
        endTime: "", // 结束时间
      },
      getDataCondition: {
        operationName: "", // 操作名称
      },
      operationModel: [],
      tableObj: {
        selection: "no", // 是否需要多选
        buttonShow: false, // 是否有添加按钮
        getData: [], // 列表数据
        formColumns: [], // 表头
        qrShow: false, // 是否需要二维码
        qrLabel: "操作名称", // table二维码label
        qrorop: "name",
        loading: true,
        tooltipShow: false,
        columnWidth: "400", // 操作按钮宽度
        buttonArr: [
          {
            name: "评分管理",
          },
          {
            name: "导出成绩报告",
          },
          {
            name: "添加学员",
          },
           {
            name: "添加监考官",
          },
        ],
      },
      qrObj: {
        title: "操作二维码",
        name: "操作名称",
      },
      loading: false,
      rowObj: {}, // 获取当前行的信息
      pageIndexs: 1, // 起始页
      eachPageNums: 10, // mixin定义的获取渲染分页序号有误
      examTime: "",
      prompt: {
        title: "温馨提示",
        info: "当前操作将导出成绩报告是否继续？",
        type: "",
      }, // 提示弹窗
      sundflag: false, // 防抖
    };
  },
  mixins: [hybrid], // 引入共用方法
  methods: {
    // chang查询
    searchChang() {
      this.pageIndexs = 1;
      this.$refs.table.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.tableObj.loading = true;
      this.getDatalist();
    },
    // 搜索
    searchData() {
      this.pageIndexs = 1;
      if (this.formLabelAlign.operationName) {
        this.getDataCondition.operationName = this.formLabelAlign.operationName;
      } else {
        this.getDataCondition.operationName = "";
      }
      this.$refs.table.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.tableObj.loading = true;
      this.getDatalist();
    },
    // 重置
    resetForm() {
      this.pageIndexs = 1;
      this.examTime = "";
      this.resetFun(this.formLabelAlign, this.getDataCondition);
      this.tableObj.loading = true;
      this.getDatalist();
    },
    // 添加
    toAdd(type) {
      // 0 新增  1 编辑
      console.log(type, "执行了父组件");
      return;
    },
    // 获取当前行
    getRow(row) {
      this.rowObj = row;
    },
    // 评分管理 scoreDetails
    fun1() {
      this.$router.push({
        path: "/operationScore/editorScore", //跳转的路径
        query: {
          ID: this.rowObj.row.ID,
        },
      });
      this.$storage.sessionSet("rowObj", this.rowObj.row, true); // 回传编辑信息
    },
    async fun2() {
      this.$refs.ComPopup.dialogVisibleObj.export = true;
    },
    // 导出成绩报告
    exportExam() {
      let port = process.env.VUE_APP_EXPORTURL;
      // 导出成绩报告
      let obj = {
        examineID: this.rowObj.row.ID,
        type: "1",
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      this.$refs.ComPopup.sundflag = true;
      assessApi.word_down(obj).then((res) => {
        if (res.data.Status == 200) {
          let link = document.createElement("a");
          // let url = `${port}${res.data.Data}`;
          let url = res.data.Data;
          link.setAttribute("target", "_blank");
          link.href = url;
          link.click();
          this.$message({
            message: `恭喜你，操作名称为${this.rowObj.row.Title}导出成绩报告成功`,
            type: "success",
          });
          setTimeout(() => {
            this.$refs.ComPopup.sundflag = false;
          }, 500);
          this.$refs.ComPopup.dialogVisibleObj.export = false;
        } else {
          this.$refs.ComPopup.sundflag = false;
          this.$message.error(data.Msg);
        }
      });
    },
    fun3() {
      // 考核中只能编辑时间，待考核可以编辑，考核结束且已评分情况不能编辑
      this.$router.push({
        path: "/operationScore/addExaminee", //跳转的路径
        query: {
          ID: this.rowObj.row.ID,
        },
      });
    },
    fun4() {
      // 添加监考官
      this.$router.push({
        path: "/operationScore/addTeacher", //跳转的路径
        query: {
          ID: this.rowObj.row.ID,
        },
      });
    },
    // 列表获取
    async getDatalist() {
      if (this.examTime) {
        const time = JSON.parse(JSON.stringify(this.examTime));
        this.formLabelAlign.beginTime = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.endTime = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      this.sundflag = true;
      let parameter = {
        title: this.getDataCondition.operationName, // 名称
        c_status: this.formLabelAlign.operationModel, // 状态(0待考核 1考核中 2考核结束 3考核关闭)
        beginTime: this.formLabelAlign.beginTime, // 开始时间
        endTime: this.formLabelAlign.endTime, // 结束时间
        pageIndex: this.pageIndexs, //当前页
        pageSize: this.eachPageNums, // 一页多少条
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await assessApi.getExamlist(parameter);
      if (data.Status == 200) {
        this.tableObj.getData = data.Msg.list;
        this.total = data.Msg.dataCount;
        this.operationData();
        setTimeout(() => {
          this.tableObj.loading = false;
          this.sundflag = false;
        }, 500);
      } else {
        this.sundflag = false;
        this.$message.error(data.Msg);
      }
    },
    // 是否禁用
    disabledFun(row, item) {
      // row 当前行的信息  item ===> 指定禁用那个按钮
      if (row.examStatus == "待考核" && item.name == "评分管理") {
        return true;
      } else if (row.examStatus !== "考核中" && item.name == "添加学员") {
        return true;
      } else {
        return false;
      }
    },
    // 是否有按钮
    buttonShowClick(row, item) {
      return true;
    },
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      if (row.examStatus === "考核中" && columnIndex === 3) {
        return "blue";
      } else if (row.examStatus === "考核结束" && columnIndex === 3) {
        return "red";
      } else if (row.examStatus === "待考核" && columnIndex === 3) {
        return "gray";
      } else if (row.Status1 === "考场关闭" && columnIndex === 4) {
        return "red";
      } else if (row.Status1 === "考场开启" && columnIndex === 4) {
        return "gray";
      }
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // this.loading = true;
      this.tableObj.loading = true;
      this.eachPageNums = val;
      this.getDatalist();
    },
    handleCurrentChange(val) {
      this.pageIndexs = val;
      console.log(`当前页: ${this.pageIndexs}`);
      // this.loading = true;
      this.tableObj.loading = true;
      this.getDatalist();
    },
    // 操作数据
    operationData() {
      let newDate = this.$moment().valueOf(); // 获取当前时间
      this.tableObj.getData = this.tableObj.getData.map((item) => {
        this.$set(
          item,
          "time",
          this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
            "-" +
            this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm")
        );
        this.$set(
          item,
          "CreateTime1",
          this.$moment(item.CreateTime).format("YYYY/MM/DD HH:mm")
        );

        this.$set(item, "TotalUser1", item.TotalUser - item.ApplyUser); // 未考人数
        this.$set(item, "Status1", item.Status == 3 ? "考核关闭" : "考核开启"); // 3为关闭其他都是开启
        if (newDate < this.$moment(item.BeginTime).valueOf()) {
          // 当前时间小于起始时间
          item.examStatus = "待考核";
        } else if (this.$moment(item.EndTime).valueOf() < newDate) {
          // 当前时间大于结束时间
          item.examStatus = "考核结束";
        } else {
          item.examStatus = "考核中";
        }
        // 考核结束 状态变成考核关闭
        if (item.examStatus == "考核结束") {
          item.Status1 = "考核关闭";
        }
        return item;
      });
    },
  },
  components: {
    Table,
    Popups,
    ComPopup,
  },
  created() {
    this.modelArr = modelArr;
    this.tableObj.formColumns = operationTable; // 表头label
    this.getDatalist(); // 获取列表
    // this.tableObj.buttonArr()
  },
};
</script>

<style lang="scss" scoped>
.training_table {
  height: 100%;
  width: 100%;
  min-height: 740px;
  background: #fff;
}
.waitingcom_title {
  height: 90px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  ::v-deep .el-form-item__content {
    margin-left: 115px !important;
  }
  .el-form {
    display: flex;
  }
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .blue .cell {
  color: #0084ea !important;
}
::v-deep .el-table .gray .cell {
  color: #999999 !important;
}
// 分页
.foot_box {
  position: relative;
  height: 140px;
  ::v-deep .el-pager li:hover {
    color: #0084ea;
  }
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #0084ea;
        border: none;
      }
    }
  }
}
</style>
